module.exports = __webpack_public_path__ + "media/images/logo-white-eb2c0d69140567ba0c83ee5beafe5479.svg";